import React, { useState } from "react";
import DashboardHeader from "./models/dashboard/DashboardHeader";
import DashboardStats from "./models/dashboard/DashboardStats";
import NeedsAttention from "./models/dashboard/NeedsAttention";
import QuickActions from "./models/dashboard/QuickActions";
import RecentActivity from "./models/dashboard/RecentActivity";
import ClientSnapshot from "./models/dashboard/ClientSnapshot";
import LoadingSpinner from "../../components/loaders/LoadingSpinner";
import "../../css/pages/ca_pages/CADashboard.css";

const CADashboard = () => {
    const [loading, setLoading] = useState(false);

    return ( loading ? <LoadingSpinner /> :
        <div className="caDashPro__container">
            {/* HEADER */}
            <DashboardHeader />

            {/* MAIN GRID */}
            <div className="caDashPro__grid">
                {/* LEFT COLUMN */}
                <div className="caDashPro__left">
                    <NeedsAttention />
                    <RecentActivity />
                </div>

                {/* RIGHT COLUMN */}
                <div className="caDashPro__right">
                    <DashboardStats />
                    <QuickActions setLoading = {setLoading} />
                    <ClientSnapshot />
                </div>
            </div>
        </div>
    );
};

export default CADashboard;
